var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCola = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_14053)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90144 9.3252C6.91313 9.34014 6.92807 9.35222 6.94513 9.36053C6.96218 9.36884 6.98091 9.37316 6.99988 9.37316C7.01885 9.37316 7.03757 9.36884 7.05463 9.36053C7.07168 9.35222 7.08662 9.34014 7.09832 9.3252L8.84832 7.11113C8.91238 7.02988 8.85457 6.90957 8.74988 6.90957H7.59207V1.62207C7.59207 1.55332 7.53582 1.49707 7.46707 1.49707H6.52957C6.46082 1.49707 6.40457 1.55332 6.40457 1.62207V6.90801H5.24988C5.14519 6.90801 5.08738 7.02832 5.15144 7.10957L6.90144 9.3252ZM12.7186 8.77832H11.7811C11.7124 8.77832 11.6561 8.83457 11.6561 8.90332V11.3096H2.34363V8.90332C2.34363 8.83457 2.28738 8.77832 2.21863 8.77832H1.28113C1.21238 8.77832 1.15613 8.83457 1.15613 8.90332V11.9971C1.15613 12.2736 1.37957 12.4971 1.65613 12.4971H12.3436C12.6202 12.4971 12.8436 12.2736 12.8436 11.9971V8.90332C12.8436 8.83457 12.7874 8.77832 12.7186 8.77832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_14053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCola, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cola.ca595af6.svg";
export { ForwardRef as ReactComponent };